import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        forms: '=',
        form: '=',
        company: '='
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.errors.evaluationGroup">
            {{ vm.form.errors.evaluationGroup }}
        </div>
        <form-row error="vm.form.errors.name">
            <label class="label">{{ 'evaluationGroup.Group name' | translate }} *</label>
            <div class="items">
                <input ng-model="vm.form.model.name" type="text" class="form-control">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.deadline">
            <label class="label">{{ 'evaluationGroup.Group deadline' | translate }}</label>
            <div class="items">
                <datetimepicker ng-model="vm.form.model.deadline"></datetimepicker>
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.formId">
          <label class="label">{{ 'evaluationGroup.Associated form' | translate }} *</label>
          <div class="items">
            <select class="form-control"
                    ng-model="vm.form.model.formId"
                    ng-disabled="vm.isFormFieldDisabled()"
                    ng-options="form.id as form.activeI18n.name for form in vm.forms">
            </select>
            <form-row-error></form-row-error>
          </div>
        </form-row>
        <form-row error="vm.form.errors.evaluationGroupI18ns[vm.company.defaultLanguage].introduction">
            <label class="label">
                {{ 'evaluation.Introduction text' | translate }}
                <small>{{ 'evaluation.introduction_text_refinement' | translate }}</small>
            </label>
            <div class="items">
                <div class="mt10">
                    <ng-ckeditor
                    class="mt10"
                    ng-model="vm.form.model.evaluationGroupI18ns[vm.company.defaultLanguage].introduction"
                    ng-config="vm.ckConfig">
                    </ng-ckeditor>
                </div>
                <form-row-error></form-row-error>
            </div>
        </form-row>
    `
})
export default class {
    constructor ($translate, EvaluationService, lodash) {
        this.$translate = $translate;
        this.EvaluationService = EvaluationService;
        this.lodash = lodash;
    }

    $onInit () {
        this.EvaluationService.convertFormFields(this.form);
        this.normalizeEvaluationGroupI18ns();
        this.ckConfig = this.EvaluationService.getCKEditorConfig();

        const lang = this.company.defaultLanguage;

        // Ensure evaluationGroupI18ns is always defined early
        if (!this.form.model.evaluationGroupI18ns) {
            this.form.model.evaluationGroupI18ns = {};
        }

        if (!this.form.model.evaluationGroupI18ns[lang]) {
            this.form.model.evaluationGroupI18ns[lang] = { introduction: '' };
        }

        if (!this.form.model.id) {
            this.getDefaultIntroduction();
        }
    }

    isFormFieldDisabled () {
        if (!this.forms) {
            return true;
        }
        if (!this.form.model.id) {
            return false;
        }

        return Number(this.form.model.completedEvaluationCount) > 0;
    }

    getDefaultIntroduction () {
        const language = this.company.defaultLanguage.toLowerCase();
        this.$translate('evaluation.introduction_text_content', { company: this.company.name }, undefined, undefined, language).then(text => {
            let introduction = text;
            const companyI18n = this.lodash.find(this.company.companyI18ns, (i18n) => {
                return this.company.defaultLanguage === i18n.language;
            });

            if (companyI18n && companyI18n.feedbackIntroduction !== null) {
                introduction = companyI18n.feedbackIntroduction;
            }

            this.form.model.evaluationGroupI18ns = {
                [this.company.defaultLanguage]: { introduction }
            };
        });
    }

    normalizeEvaluationGroupI18ns () {
        const lang = this.company.defaultLanguage;

        if (!this.form.model.evaluationGroupI18ns) {
            this.form.model.evaluationGroupI18ns = {};
        }

        // If array, convert to object keyed by language, depending on how backend sends data
        if (Array.isArray(this.form.model.evaluationGroupI18ns)) {
            const obj = {};
            this.form.model.evaluationGroupI18ns.forEach(i18n => {
                obj[i18n.language] = i18n;
            });
            this.form.model.evaluationGroupI18ns = obj;
        }

        if (!this.form.model.evaluationGroupI18ns[lang]) {
            this.form.model.evaluationGroupI18ns[lang] = { introduction: '' };
        }
        else if (!this.form.model.evaluationGroupI18ns[lang].introduction) {
            this.form.model.evaluationGroupI18ns[lang].introduction = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/form/index.js